module.exports = __webpack_public_path__ + "img/gb_yy.f8aa249d.png";